<template>
  <div :class="$style.wrap">
    <base-form
      ref="form"
      :items="data"
      :locked="locked"
      label-width="5em"
      submit-text="确定"
      @submit="onSubmit"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BaseForm from "@/components/BaseForm";
import { bindIdentity } from "@/http/account";
import { mixinForward } from "@/mixins/mixinForward";

export default {
  name: "Identity",
  components: { BaseForm },
  mixins: [mixinForward],
  data() {
    return {
      locked: false, // 锁定表单不可提交
      data: [{ name: "idName" }, { name: "idNumber" }]
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    if (this.userInfo.name && this.userInfo.id_code) {
      this.locked = true;

      // 姓名
      this.$set(
        this.data,
        0,
        Object.assign({}, this.data[0], {
          value: this.userInfo.name,
          readonly: true
        })
      );

      // 身份证
      this.$set(
        this.data,
        1,
        Object.assign({}, this.data[1], {
          value: this.userInfo.id_code,
          readonly: true
        })
      );
    }
  },
  methods: {
    /**
     * @description 实名认证
     * @param {object} formdata  - 表单对象值
     */
    onSubmit(formdata) {
      bindIdentity({
        name: formdata.idName,
        identity: formdata.idNumber
      })
        .then(res => {
          if (res.rcode === 0) {
            this.locked = true;
            this.success(res.rdesc, {
              countdown: true,
              callback: () => {
                if (this.forward) {
                  location.href = this.forward;
                } else {
                  this.$router.replace({ path: this._anchor.profile.path });
                }
              }
            });
          }
        })
        .finally(() => {
          this.$refs.form.disabled = false;
        });
    }
  }
};
</script>
<style lang="less" module>
.wrap {
  padding-top: 1.68rem;
}
</style>
